import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
var rs = /*#__PURE__*/function () {
  function rs(t) {
    _classCallCheck(this, rs);
    this.wc = t, this.wc = t;
  }
  _createClass(rs, [{
    key: "xc",
    value: function xc(t) {
      return null == this.wc || this.wc === t[0];
    }
  }, {
    key: "dt",
    value: function dt() {
      return this.wc;
    }
  }], [{
    key: "fromJson",
    value: function fromJson(t) {
      return new rs(t ? t.event_name : null);
    }
  }]);
  return rs;
}();
export { rs as default };